import { render, staticRenderFns } from "./ModalEditDataArea.vue?vue&type=template&id=33296b68"
import script from "./ModalEditDataArea.vue?vue&type=script&lang=js"
export * from "./ModalEditDataArea.vue?vue&type=script&lang=js"
import style0 from "./ModalEditDataArea.vue?vue&type=style&index=0&id=33296b68&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33296b68')) {
      api.createRecord('33296b68', component.options)
    } else {
      api.reload('33296b68', component.options)
    }
    module.hot.accept("./ModalEditDataArea.vue?vue&type=template&id=33296b68", function () {
      api.rerender('33296b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ModalEditDataArea.vue"
export default component.exports